import React, { useState } from 'react';
import { Calendar, Phone, MapPin, Briefcase, User, Award } from 'lucide-react';
import { useToast } from '../hooks/use-toast';
import { publicApi } from '../api/client';

const INITIAL_FORM = {
  surname: '', name: '', fatherName: '', birth: '', phone: '+994 (050 ) 555 55', city: '', specialty: '', workplace: '', position: '',
};

function FormField({ placeholder, value, onChange, icon }) {
  return (
    <div className="form-field">
      <input placeholder={placeholder} value={value} onChange={onChange} />
      {icon && <span className="icon">{icon}</span>}
    </div>
  );
}

function useContactForm() {
  const { toast } = useToast();
  const [form, setForm] = useState(INITIAL_FORM);
  const [submitting, setSubmitting] = useState(false);

  const upd = (k) => (e) => setForm((prev) => ({ ...prev, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await publicApi.submitContact(form);
      toast({ title: 'Müraciətiniz göndərildi', description: 'Tezliklə sizinlə əlaqə saxlayacağıq.' });
      setForm(INITIAL_FORM);
    } catch {
      toast({ title: 'Xəta baxş verdi', description: 'Yenidən cəhd edin.' });
    } finally {
      setSubmitting(false);
    }
  };

  return { form, upd, submit, submitting };
}

export default function Contact() {
  const { form, upd, submit, submitting } = useContactForm();

  return (
    <section className="section">
      <div className="container">
        <h2 className="section-title">Əlaqə</h2>
        <p className="section-subtitle">Bizimla əlaqə saxlayın</p>
        <form className="contact-form" onSubmit={submit}>
          <div className="form-grid">
            <FormField placeholder="Soyad" value={form.surname} onChange={upd('surname')} />
            <FormField placeholder="Doğum tarixi" value={form.birth} onChange={upd('birth')} icon={<Calendar size={16} />} />
            <FormField placeholder="Ixdisas" value={form.specialty} onChange={upd('specialty')} icon={<Award size={16} />} />
            <FormField placeholder="Ad" value={form.name} onChange={upd('name')} icon={<User size={16} />} />
            <FormField placeholder="+994 (050 ) 555 55" value={form.phone} onChange={upd('phone')} icon={<Phone size={16} />} />
            <FormField placeholder="İş yeri" value={form.workplace} onChange={upd('workplace')} icon={<Briefcase size={16} />} />
            <FormField placeholder="Ata adı" value={form.fatherName} onChange={upd('fatherName')} />
            <FormField placeholder="Yaşadığı şəhər" value={form.city} onChange={upd('city')} icon={<MapPin size={16} />} />
            <FormField placeholder="Vəzifəsi" value={form.position} onChange={upd('position')} icon={<Briefcase size={16} />} />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: 30 }}>
            <button type="submit" disabled={submitting} className="pill pill-teal" style={{ padding: '12px 40px', fontSize: 15 }}>
              {submitting ? 'Göndərilir...' : 'Göndər'}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}
